import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import DataActions from '../redux/dataRedux'
import MeasuresLayer from './EnergirMeasures'
import removeLayers from '../utility/removeLayers'

const id = 'Petrobras'
const authId = 'Petrobras'
const datetimeId = 'Petrobras'

class MultiLayer extends Component {
  state = {
    currentTime: new Date().getTime(),
    times: [
      {
        time: new Date('2019-03-16').getTime(),
        layers: {
          'Petrobras': {
            id: 'Petrobras',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-03-16/{z}/{x}/{y}.png`,
            time: new Date('2019-03-16').getTime()
          },
          'Petrobras-base': {
            id: 'Petrobras-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-03-16-alternate/{z}/{x}/{y}.png`,
            time: new Date('2019-03-16').getTime()
          },
        }
      },
      {
        time: new Date('2019-03-06').getTime(),
        layers: {
          'Petrobras': {
            id: 'Petrobras',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-03-06/{z}/{x}/{y}.png`,
            time: new Date('2019-03-06').getTime()
          },
          'Petrobras-base': {
            id: 'Petrobras-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-03-09/{z}/{x}/{y}.png`,
            time: new Date('2019-03-09').getTime()
          },
        }
      },
      {
        time: new Date('2019-02-24').getTime(),
        layers: {
          'Petrobras': {
            id: 'Petrobras',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-02-24/{z}/{x}/{y}.png`,
            time: new Date('2019-02-24').getTime()
          },
          'Petrobras-base': {
            id: 'Petrobras-base',
            url: `https://d3uoxf5ku9eg3c.cloudfront.net/petrobras/2019-03-03/{z}/{x}/{y}.png`,
            time: new Date('2019-03-03').getTime()
          },
        }
      },
    ]
  }

  componentDidMount () {
    const { map } = this.context

    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context

    map.off('mousemove', id, this.handleMouseMove)
    // map.off('load', this.handleLoad)
  }

  shouldComponentUpdate(nextProps) {
      if (nextProps.paint !== this.props.paint) {
        return false
      } else if (nextProps === this.props) {
        return false
      }
      return true
    }

  reducer = (state, action) => {
    switch (action.type) {
      case 'SET_TIME': {
        return { ...state, currentTime: action.time }
      }
    default:
      return state
    }
  }

  getLayerUrl = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)
    const url = item ? item.layers[id].url : times[times.length - 1].layers[id].url

    return url
  }



  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps(props) {
    const { paint, layout, before, layerOptions } = this.props

    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
        key === 'raster-opacity' && map.getLayer(`${id}-base`) && map.setPaintProperty(`${id}-base`, key, paintDiff[key] > 0.9 ? 0 : 1)
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  handleLoad = event => {
    // console.log('load')
    // console.log(event)
    // removeLayers(map, 'label')
  }
  
  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    removeLayers(map, 'label')
    if (!layerRendered) {
      return null
    }
    return null
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    const data = features.map(feature => feature.properties)
    if (data) {
      // console.log(data)
      actions.dataUpdated(data[0], 'hover')
    }
  }

  render() {
    const { idToken, layerRendered, paint, time, format = 'png' } = this.props
    const { currentTime } = this.state

    if (!layerRendered) {
      return null
    }
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : '2017-05-16T15:49:11.026Z'

    return <>
      <Source
        key={`${id}-source`}
        id={id}
        tileJsonSource={{
          type: 'raster',
          tiles: [this.getLayerUrl({ id, time: time })],
          tileSize: 512,
          scheme: 'tms',
          minzoom: 0,
          maxzoom: 15
        }}
      />
             <Source
               key={`${id}-base`}
               id={`${id}-base`}
               tileJsonSource={{
                 type: 'raster',
                 tiles: [this.getLayerUrl({ id: `${id}-base`, time: time })],
                 tileSize: 512,
                 scheme: 'tms',
                 minzoom: 0,
                 maxzoom: 15
               }}
             />
             <Layer
               key={`${id}-base-layer`}
               type='raster'
               id={`${id}-base`}
               sourceId={`${id}-base`}
               layout={{
               }}
               paint={{ 'raster-opacity': 0 }}
               before={before}
             />
      <Layer
        key={`${id}-layer`}
        type='raster'
        id={id}
        sourceId={id}
        layout={{
        }}
        paint={paint}
        before={before}
      />             
             <MeasuresLayer />
    </>
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = (state) => {

    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, 'default'),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId || id] || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      pointDataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, `${id}Point`, event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(MultiLayer)



// WEBPACK FOOTER //
// ./src/layers/Petrobras.js